import BaseAPI from './base-api'

export default new BaseAPI()
